import { RowCrudStatus } from "../../common/types";
import {
  PlatformLinkType,
  PlatformLinkTypeCreateMutationVariables,
  PlatformLinkTypeUpdateMutationVariables,
} from "../../../api/graphql";
import { LangStore } from "../../../store";

export type PlatformLinkTypeValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  name: string;
};

export type PlatformLinkTypeErrorsType = {
  name?: { message: string; fieldLabel: string };
};

export function PlatformLinkTypeValuesInit(): PlatformLinkTypeValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    name: "",
  };
}

export type PlatformLinkTypeType =
  | PlatformLinkType
  | PlatformLinkTypeValuesType;

export function platformLinkTypeDisplayId(
  source: Partial<PlatformLinkType>,
  _langStore: LangStore
) {
  return source.name ?? _langStore.emptyStringSymbol;
}

export function getPlatformLinkTypeValues(
  source: PlatformLinkTypeType,
  _langStore: LangStore,
  _duplicated: boolean = false
): PlatformLinkTypeValuesType {
  const entityValues = PlatformLinkTypeValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : platformLinkTypeDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.name = source.name;
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}

export function getPlatformLinkTypeUpdateVariables(
  values: PlatformLinkTypeValuesType
): PlatformLinkTypeUpdateMutationVariables {
  return {
    id: values.id,
    version_: values.version_,
    name: values.name,
  };
}

export function getPlatformLinkTypeCreateVariables(
  values: PlatformLinkTypeValuesType
): PlatformLinkTypeCreateMutationVariables {
  return {
    name: values.name,
  };
}
